<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{ title }}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <div class="row">
    <div class="col-md-12">
      <!-- Key Information -->
      <div class="main-hdr-bg">
        <b>Key:</b>&nbsp;
        <div style="display: inline-block; margin-left: 5px;">LEID - LE Name - - Rpt - BSLA - CUR</div>
      </div>

      <!-- Entity Holder - Less than 10 entities -->
      @if (entities.length < 10) {
<div class="entitie-holder">
        @for (entity of entities; track $index; let i = $index) {
<div class="entity-btn-group"
            
             [title]="entity.data?.SCHDM_DESC || ''">
          <button type="button" class="btn btn-xs btn-default entity-label">
            {{ entity.data?.LEID }}-{{ entity.data?.LE_NAME }}-{{ entity.data?.HO_CDR_NO }}-{{ entity.data?.REPORTING_PERIOD }}-{{ entity.data?.ME_CODE }}-{{ entity.data?.CURR }}
          </button>
          <button type="button"
                  (click)="removeEntity(i)"
                  class="btn btn-xs btn-danger entity-remove">
            <span class="fa fa-times"></span>
          </button>
        </div>
}
      </div>
}

      <!-- Entity Holder - 10 or more entities -->
      @if (entities.length >= 10) {
<div class="entitie-holder">
        <div>
          <label>Selected Entities Count : <span class="badge badge-pill badge-info">{{ entities.length }}</span></label>
        </div>
      </div>
}
    </div>
  </div>
</div>

<!-- Modal Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button"
          type="button"
          (click)="saveDormat()"
          [disabled]="btnDisabled">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
  </button>
  <button class="cancel-button warning"
          type="button"
          (click)="cancel()"
          [disabled]="btnDisabled">
    Cancel
  </button>
</div>
